(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pf-hero-slideshow"] && !Shopify.designMode) return;
  try {
    
  class PfHeroSlider extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.slides = Array.from(this.querySelectorAll('[data-pf-slide]'));
      this.prevButton = this.querySelector('[data-pf-prev]');
      this.nextButton = this.querySelector('[data-pf-next]');
      this.dotsContainer = this.querySelector('[data-pf-dots]');
      this.index = Math.max(0, this.slides.findIndex((slide) => slide.classList.contains('is-active')));
      this.autoplay = this.dataset.autoplay === 'true';
      this.speed = Number(this.dataset.speed || 5000);
      this.pauseOnHover = this.dataset.pauseOnHover === 'true';
      this.timer = null;

      this.renderDots();
      this.goTo(this.index, false);
      this.bindEvents();
      this.start();
    }

    disconnectedCallback() {
      this.stop();
    }

    bindEvents() {
      this.prevButton?.addEventListener('click', () => this.goTo(this.index - 1));
      this.nextButton?.addEventListener('click', () => this.goTo(this.index + 1));

      if (this.pauseOnHover) {
        this.addEventListener('mouseenter', () => this.stop());
        this.addEventListener('mouseleave', () => this.start());
        this.addEventListener('focusin', () => this.stop());
        this.addEventListener('focusout', () => this.start());
      }

      document.addEventListener('shopify:block:select', (event) => {
        const slide = event.target?.closest?.('[data-pf-slide]');
        if (!slide || !this.contains(slide)) return;
        const nextIndex = this.slides.indexOf(slide);
        if (nextIndex >= 0) {
          this.stop();
          this.goTo(nextIndex);
        }
      });
    }

    renderDots() {
      if (!this.dotsContainer || this.slides.length <= 1) return;
      this.dotsContainer.innerHTML = '';
      this.dots = this.slides.map((slide, index) => {
        const dot = document.createElement('button');
        dot.type = 'button';
        dot.className = 'pf-hero__dot';
        dot.setAttribute('aria-label', `Ir al slide ${index + 1}`);
        dot.addEventListener('click', () => this.goTo(index));
        this.dotsContainer.append(dot);
        return dot;
      });
    }

    goTo(nextIndex, shouldRestart = true) {
      if (!this.slides.length) return;
      const total = this.slides.length;
      this.index = ((nextIndex % total) + total) % total;

      this.slides.forEach((slide, index) => {
        const active = index === this.index;
        slide.classList.toggle('is-active', active);
        slide.setAttribute('aria-hidden', active ? 'false' : 'true');
      });

      this.dots?.forEach((dot, index) => {
        dot.classList.toggle('is-active', index === this.index);
        dot.setAttribute('aria-current', index === this.index ? 'true' : 'false');
      });

      if (shouldRestart) {
        this.stop();
        this.start();
      }
    }

    start() {
      if (!this.autoplay || this.slides.length <= 1) return;
      this.stop();
      this.timer = window.setInterval(() => this.goTo(this.index + 1, false), this.speed);
    }

    stop() {
      if (!this.timer) return;
      window.clearInterval(this.timer);
      this.timer = null;
    }
  }

  if (!customElements.get('pf-hero-slider')) {
    customElements.define('pf-hero-slider', PfHeroSlider);
  }

  } catch(e) { console.error(e); }
})();
})();
